import { t } from "@lingui/core/macro"
import { CAUTION_PASSWORD } from "../constants"
import { useMessagingView } from "../hooks"
import { classNames } from "../utils"
import styles from "./MessageRowDisclaimer.module.scss"

type Props = {
    username: string
}

export const MessageRowDisclaimer: React.FC<Props> = ({ username }) => {
    const messagingView = useMessagingView()
    const isDesktop = !messagingView.isMobile

    return (
        <div
            className={classNames(styles.messageRowDisclaimer, {
                [styles.desktop]: isDesktop,
            })}
            data-testid="notices"
        >
            <div
                className={styles.messageRowNotice}
            >{t`Private conversation with ${username}`}</div>
            <div className={styles.messageRowNotice}>{t(CAUTION_PASSWORD)}</div>
        </div>
    )
}
